import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { DeleteSegmentMobile } from './DeleteSegment';

export const SegmentHeaderMobile = ({ index, totalSegments }) => {
    const { t } = useTranslation();
    const legNumber = index + 1;
    return totalSegments > 1 ? (
        <div
            className="odf-flex-container-row odf-flex-container-justify-between
            odf-flex-container-nogutter odf-space-outer-top-l"
        >
            <div className="odf-flex-item odf-h3 odf-text-left">
                {t('flightsManager.flightNumber', { number: legNumber.toString() })}
            </div>
            <div className="odf-flex-item odf-flex-item-sm odf-text-action">
                <DeleteSegmentMobile index={index} />
            </div>
        </div>
    ) : (
        <React.Fragment />
    );
};

SegmentHeaderMobile.propTypes = {
    index: PropTypes.number.isRequired,
    totalSegments: PropTypes.number.isRequired,
};
